import { useCallback, useMemo, useState } from 'react'

import { useProcessInternalTransferExport } from 'commons/hooks/bank/internalTransfer'
import { InternalTransfersExportList } from 'commons/types/DTO/bank'
import { Keys, useStateManager } from 'state-manager'
import { DataSourceItem } from 'ui/components/Table'
import { Toast } from 'ui/components/Toast'
import { useConfirmation } from 'ui/hooks'

import { handlerServerError } from '@orbit/errors'

export const useTable = (
  internalTransferExports: InternalTransfersExportList[],
  setLoading: (isLoading: boolean) => void
) => {
  const [selectedTransfer, setSelectedTransfer] = useState<null | InternalTransfersExportList>(null)
  const sm = useStateManager()

  const mappedInternalTransfersExport: DataSourceItem<InternalTransfersExportList>[] = useMemo(
    () =>
      internalTransferExports.map((el) => ({
        item: el
      })),
    [internalTransferExports]
  )

  const { routine: processInternalTransferExport } = useProcessInternalTransferExport({
    onSuccess: async () => {
      await sm.invalidate(Keys.InternalTransfer.ListByCriteria({}))
      Toast.successSmall('File was processed.')
      setLoading(false)
    },
    onError: (error) => {
      handlerServerError(error)
      setLoading(false)
    }
  })

  const { open, Confirmation: ProcessConfirmation } = useConfirmation({
    message: `Are you sure you want to process ITE-${selectedTransfer?.id} export?`,
    onConfirm: () => {
      setLoading(true)
      processInternalTransferExport(selectedTransfer?.id)
    },
    confirmationButtonText: 'Process'
  })

  const startInternalTransferExport = useCallback(
    (item: InternalTransfersExportList) => {
      setSelectedTransfer(item)
      open()
    },
    [setSelectedTransfer, open]
  )

  return {
    ProcessConfirmation,
    startInternalTransferExport,
    mappedInternalTransfersExport
  }
}
